/**
 * Retorna o estilo CSS associado a um status da instalação da fatura específico.
 *
 * @param {string} name - O nome do status de resumo da fatura.
 * @returns {string} O estilo CSS associado ao status de resumo da fatura.
 *
 * @example
 * const style = setPanoramaInvoiceInstallationStatusColor('CONNECTING');
 * console.log(style); // Output: 'width: 200px; color: #C40C0C;'
 */

export function setPanoramaInvoiceInstallationStatusColor(name) {
  const panoramaInvoiceSummaryStatusColorMap = {
    'CONNECTING': 'color: #28a745;',
    'INACTIVATION_REQUESTED': 'color: #850F8D;',
    'DEBT': 'color: #C40C0C;',
  };
  return panoramaInvoiceSummaryStatusColorMap[name];
}
